import {IBank} from 'app/blocks/model/bank.model';
import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {IContactInfo} from 'app/blocks/model/contact-info.model';

export interface IFranchise extends IBaseEntity {
    id?: number;
    name?: string;
    code?: string;
    vatRegNo?: string;
    contactInfoi?: IContactInfo;
    bankAccounts?: IBank[];
    registrationNo?: string;
}

export class Franchise extends BaseEntity implements IFranchise {
    id?: number;
    name?: string;
    code?: string;
    vatRegNo?: string;
    contactInfo?: IContactInfo;
    bankAccounts?: IBank[];
    registrationNo?: string;

    constructor(franchise?) {
        super();
        if (franchise) {
            this.id = franchise.id;
            this.name = franchise.name;
            this.code = franchise.code;
            this.vatRegNo = franchise.vatRegNo;
            this.contactInfo = franchise.contactInfo;
            this.bankAccounts = franchise.bankAccounts;
            this.registrationNo = franchise.registrationNo;
        }
    }

    clone(): Franchise {
        return new Franchise(this);
    }

    get discriminator(): any {
        return this.name;
    }
}
